import React from 'react';
import styles from './Card.module.scss';

// 圆角柔和卡片容器
export default function Card ({children, className = '', as: Tag = 'div', pad = true, ...rest}) {
    return (
        <Tag className={[styles.card, pad ? styles.pad : '', className].filter(Boolean).join(' ')} {...rest}>
            {children}
        </Tag>
    );
}
